<template>
  <b-dropdown position="is-bottom-left">
    <button
      class="button is-primary"
      slot="trigger"
      :class="{ 'is-loading': form.processing }"
    >{{$t('publisher.add')}}</button>

    <b-dropdown-item @click="create('organization')">
      <div class="media">
        <b-icon class="media-left" icon="sitemap"></b-icon>
        <div class="media-content">
          <h3>{{$tc('organization')}}</h3>
          <small>Organization, publishing company</small>
        </div>
      </div>
    </b-dropdown-item>

    <b-dropdown-item @click="create('person')">
      <div class="media">
        <b-icon class="media-left" icon="account-outline"></b-icon>
        <div class="media-content">
          <h3>{{$tc('person')}}</h3>
          <small>Person ...</small>
        </div>
      </div>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
export default {
  data() {
    return {
      form: new window.Form({
        type: null
      }).takeAtLeast(500)
    };
  },

  methods: {
    create(type) {
      this.form.type = type;

      this.form.post("/admin/api/publishers").then(response => {
        this.$router.push("/publishers/" + response.data.id + "/edit");
      });
    }
  }
};
</script>
